import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/internal/operators/map';
import { catchError } from 'rxjs/internal/operators/catchError';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  url = environment.apiBaseUrl;

  constructor(
    private router: Router,
    private http: HttpClient) { }

    async reloadRoute(path: string) {
      this.router.navigateByUrl('/dashboard1', { skipLocationChange: true }).then(() => {
        setTimeout(() => {
          this.router.navigateByUrl(path);
        }, 50); // 50ms delay
      });
      
    }

  saveTimespentonPages(data: any) {
    return this.http.post<{ data }>(`${this.url}ipj/timeTracking/saveProgram`, data, {withCredentials: true}).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    )
  }

}
